class NonceEvent {
  events: Record<string, Function>;
  constructor() {
    this.events = {};
  }
  on(nonce: string, fn: (...args: any[]) => void) {
    this.events[nonce] = fn;
  }
  emit(nonce: string, data: unknown) {
    if (this.events[nonce]) {
      this.events[nonce](data);
      delete this.events[nonce];
    }
  }
}
export default new NonceEvent();
